import { render, staticRenderFns } from "./DialogEliminaSquadra.vue?vue&type=template&id=6f82cfb4&scoped=true&"
import script from "./DialogEliminaSquadra.vue?vue&type=script&lang=js&"
export * from "./DialogEliminaSquadra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f82cfb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f82cfb4')) {
      api.createRecord('6f82cfb4', component.options)
    } else {
      api.reload('6f82cfb4', component.options)
    }
    module.hot.accept("./DialogEliminaSquadra.vue?vue&type=template&id=6f82cfb4&scoped=true&", function () {
      api.rerender('6f82cfb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogEliminaSquadra.vue"
export default component.exports